













































import {
  Component, Emit, Prop,
} from 'vue-property-decorator';

import { ValidationObserver, ValidationProvider } from 'vee-validate';
import VueMultiselect from 'vue-multiselect';
import TransactionParticipant from '@/models/TransactionParticipant';
import TransactionParticipantModal from '@/components/TransactionParticipantModal.vue';
import TransactionParticipantForm, { TransactionParticipantDto } from '@/components/TransactionParticipantForm.vue';

@Component({
  name: 'DebtorModal',
  components: {
    ValidationProvider, ValidationObserver, VueMultiselect, TransactionParticipantForm,
  },
  inheritAttrs: false,
})
export default class DebtorModal extends TransactionParticipantModal {
  @Prop({
    type: Array,
    default: () => [],
  })
  readonly debtors!: TransactionParticipant[];

  closeModalOnEsc = true;

  isFormShown = false;

  get isFormShownComputed() {
    return Boolean(this.isFormShown || this.name || this.iban);
  }

  onAddDebtorClick() {
    this.isFormShown = true;
  }

  @Emit('submit')
  onSubmit(transactionParticipantDto: TransactionParticipantDto) {
    return transactionParticipantDto;
  }

  @Emit('delete')
  onDelete() {
    return this.id;
  }

  @Emit('update:visible')
  onCancel() {
    return false;
  }

  @Emit('debtor:select')
  onDebtorSelect(debtor: TransactionParticipant) {
    return debtor;
  }
}
